import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import useUserStore from 'stores/user';
import { PermissionsContext } from './PermissionsContext';
import { defineAbilityFor } from './abilities';
var PermissionsProvider = function (_a) {
    var children = _a.children;
    var teamsPermission = useUserStore(function (s) { return s.userPermissions; });
    var abilities = useMemo(function () { return defineAbilityFor(teamsPermission); }, [teamsPermission]);
    return (_jsx(PermissionsContext.Provider, { value: abilities, children: children }));
};
export default PermissionsProvider;
